import { useWishlist } from "@/context/wishlist";
import { useSession } from "next-auth/react";
import { ModalContext } from "@/pages/_app";
import { useCart } from "@/context/cart";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";

import Link from "next/link";
import HomeIcon from "@/components/icons/HomeIcon";
import UserIcon from "@/components/icons/UserIcon";
import CartIcon from "@/components/icons/CartIcon";
import HeartIcon from "@/components/icons/HeartIcon";
import CategoryIcon from "@/components/icons/CategoryIcon";
import ActiveHomeIcon from "@/components/icons/ActiveHomeIcon";
import { useClient } from "@/hooks/useClient";
import CookieConsent from "@/components/CookieConsent";

const FixedBox = ({ locale }) => {
  const { cart } = useCart();
  const { isClient } = useClient();

  const { pathname, push } = useRouter();
  const { data: session } = useSession();
  const [wishlistState, setWishlistState] = useState();
  const { wishlist } = useWishlist();
  const wishlistCount = Object.keys(wishlist || {})?.length;
  const Context = useContext(ModalContext);
  useEffect(() => {
    setWishlistState(wishlistCount);
  }, [wishlistCount]);
  return (
    <div className="fixed bottom-0 shadow-inner left-0 block w-full p-2 bg-white lg:hidden z-mega-menu">
      <div className="flex items-center justify-between px-3 pb-2">
        <Link
          aria-label="Home"
          href="/"
          prefetch={false}
          className={`flex flex-col items-center gap-0.5 ${
            pathname === "/" ? "text-secondary-900" : " text-secondary-600"
          }`}
        >
          {pathname === "/" ? (
            <ActiveHomeIcon className="size-6" />
          ) : (
            <HomeIcon className="size-6" />
          )}
          <span className="text-xs sm:text-base">
            {locale === "en" ? "Home" : "الرئيسية"}
          </span>
        </Link>
        <Link
          aria-label="Category"
          href="/categories"
          prefetch={false}
          className="flex flex-col items-center gap-0.5 text-secondary-600"
        >
          <CategoryIcon className="size-6" />
          <span className="text-xs sm:text-base">
            {locale === "en" ? "Category" : "التصنيفات"}
          </span>
        </Link>
        <Link
          aria-label="Cart"
          href="/cart"
          prefetch={false}
          className={`relative -mt-14 size-16 rounded-full ${
            pathname === "/cart" ? "bg-blue-600" : "bg-primary"
          } text-white border-4 border-white flex items-center justify-center`}
        >
          <CartIcon className="size-6" />
          <span className="absolute flex items-center justify-center text-xs font-bold bg-white rounded-full top-2 right-2 size-4 text-secondary-800">
            {isClient ? cart?.cartItems?.length : 0}
          </span>
        </Link>
        <Link
          aria-label="Favourite"
          href="/user/favourite"
          prefetch={false}
          className={`flex flex-col items-center gap-0.5 ${
            pathname === "/user/favourite"
              ? "text-secondary-900"
              : " text-secondary-600"
          } relative`}
        >
          <span className="relative">
            <HeartIcon className="size-6" />
            {wishlistState ? (
              <span className="absolute -top-1.5 -right-1.5 flex items-center justify-center text-xs text-white rounded-full size-4 bg-primary-800">
                {wishlistState}
              </span>
            ) : (
              ""
            )}
          </span>
          <span className="text-xs sm:text-base">
            {locale === "en" ? "Favourites" : "المفضلة"}
          </span>
        </Link>
        <div
          className={`flex flex-col items-center gap-0.5 ${
            pathname.includes("/user") && pathname === "/user/favourite"
              ? "text-secondary-900"
              : "text-secondary-600"
          }`}
          onClick={() =>
            !session?.user ? Context?.dispatch({ type: "auth" }) : push("/user")
          }
        >
          <UserIcon className="size-6" />
          <span className="text-xs sm:text-base">
            {locale === "en" ? "User" : "المستخدم"}
          </span>
        </div>
      </div>
      <CookieConsent className="flex md:hidden" />
    </div>
  );
};

export default FixedBox;
